import { AbstractControl, Validators } from '@angular/forms';
import { SfInputFormField } from 'ngx-smart-form';
import { IFormField } from 'ngx-smart-form/lib/smart-form/interfaces/i-form-field';

export class CfFormField<T> extends SfInputFormField<T> {
  constructor(field: Partial<IFormField<T>>) {
    super(<IFormField<T>>{
      formControlName: 'codiceFiscale',
      label: 'Codice fiscale',
      validators: [
        Validators.pattern(
          '^[0-9]{11}$|^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$'
        ),
      ],
      ...field,
    });
  }

  override setControlRef(ctrlRef: AbstractControl<any, any> | null): void {
    super.setControlRef(ctrlRef);
    ctrlRef?.valueChanges.subscribe((val) =>
      this.controlRef?.setValue(val?.toUpperCase(), { emitEvent: false })
    );
  }
}
